module.exports = __webpack_public_path__ + "images/00bd9a38e73b64a7a8e9b9de4b50a633.png";